import React from 'react';
import { v4 as uuidv4 } from "uuid";
import '../css/initiatives.css';
import nagPanchami from '../assets/images.jpeg';
import janmashtami from '../assets/images12.jpeg';
import teej from '../assets/Unknown.jpeg';

const InitiativesEvents = () => {
  const events = [
    { key: uuidv4(), image: nagPanchami, title: "Nag Panchami", date: "July 30, 2025", description: "A festival dedicated to the worship of snakes with milk offerings." },
    { key: uuidv4(), image: janmashtami, title: "Krishna Janmashtami", date: "August 16, 2025", description: "Celebrating Lord Krishna’s birth with fasting and night prayers." },
    { key: uuidv4(), image: teej, title: "Hartalika Teej", date: "August 28, 2025", description: "A significant festival where married women fast for their husband's well-being." }
  ];

  return (
    <div className="container">
      <section className="events-section">
        <h1>Upcoming Festivals</h1>
        <div className="cards-container">
          {events.map((event) => (
            <div key={event.key} className="card">
              <img src={event.image} alt={event.title} className="event-image" />
              <div className="card-content">
                <h3>{event.title}</h3>
                <p className="event-date">{event.date}</p>
                <p className="event-description">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default InitiativesEvents;
